export default function NewPageIcon({
  className = "w-5 h-5 ml-4",
}: {
  className?: string;
}) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        className={className}
      >
        <polygon
          fill="currentColor"
          points="5 4.31 5 5.69 9.33 5.69 2.51 12.51 3.49 13.49 10.31 6.67 10.31 11 11.69 11 11.69 4.31 5 4.31"
          data-v-3154cec8=""
        ></polygon>
      </svg>
    </div>
  );
}
